import { render, staticRenderFns } from "./IssuePhonTable.vue?vue&type=template&id=2753e637&scoped=true&"
import script from "./IssuePhonTable.vue?vue&type=script&lang=js&"
export * from "./IssuePhonTable.vue?vue&type=script&lang=js&"
import style0 from "./IssuePhonTable.vue?vue&type=style&index=0&id=2753e637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2753e637",
  null
  
)

export default component.exports